import { useEffect, useState } from "react";
import { useCaja } from "../../../contexto/provider/CajaSesionContext.js";

import TituloModulo from "../../../componentsUI/estructura/tituloModulos/tituloModulo.js";
import BotonAccion from "../../../componentsUI/formularios/button/BotonAction.js";
import { ahora } from "../../../../utils/fechas.js";
import { formatearPrecio } from "../../../../utils/precios.js";

import "./form.css";

export default function FormularioCierreCaja({ onCerrada }) {
  const { cerrarCaja, obtenerSesionAbiertaPorDia } = useCaja();

  // Estados para controlar inputs y datos
  const [saldoInicial, setSaldoInicial] = useState("");
  const [ventasEfectivo, setVentasEfectivo] = useState("");
  const [observaciones, setObservaciones] = useState("");

  // calculo saldo
  const saldoFinalCalculado =
    Number(saldoInicial || 0) + Number(ventasEfectivo || 0);

  // datos para validar sesión abierta
  const punto = 101;
  //const hoy = "2026-02-22"; // ejemplo
  const hoy = ahora().split("T")[0];

useEffect(() => {
  const validarSesion = async () => {
    const sesion = await obtenerSesionAbiertaPorDia({ punto, fecha: hoy });
    if (sesion) {
      setSaldoInicial(sesion.saldoInicial);
      setObservaciones(sesion.observaciones || "");
    }
  };

  validarSesion();
}, [hoy, obtenerSesionAbiertaPorDia, punto]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (ventasEfectivo === "") return;

    const payload = {
      usuarioId: 1,
      punto,
      fecha: hoy,
      saldoFinalDeclarado: saldoFinalCalculado,
      observaciones,
    };
    console.log("📦 Cierre Caja → payload:", payload);
    const sesionCerrada = await cerrarCaja(payload);
    console.log("✅ Respuesta backend:", sesionCerrada);
    onCerrada?.(sesionCerrada);
  };

  return (
    <div>
      {" "}
      <TituloModulo titulo="Cierre de caja" />
      <div className="form-containere">
        <form onSubmit={handleSubmit} className="grid-caja">
          {/* Fila 1 */}
          <div className="campo-caja">
            <label>Punto</label>
            <div className="valor">{punto}</div>
          </div>

          <div className="campo-caja">
            <label>Fecha</label>
            <div className="valor">{hoy}</div>
          </div>

          {/* Fila 2 */}
          <div className="campo-caja">
            <label>Saldo inicial Efectivo</label>
            <div className="valor">{formatearPrecio(saldoInicial)}</div>
          </div>

          <div className="campo-caja">
            <label>Ventas Efectivo</label>
            <input
              type="text"
              inputMode="numeric"
              placeholder="0"
              value={ventasEfectivo ? formatearPrecio(ventasEfectivo) : ""}
              onChange={(e) =>
                setVentasEfectivo(e.target.value.replace(/\D/g, ""))
              }
            />
          </div>

          <div className="campo-caja">
            <label>Saldo Final Calculado</label>
            <div className="valor">{formatearPrecio(saldoFinalCalculado)}</div>
          </div>

          {/* Fila 3 */}
          <div className="campo-caja">
            <label>Observaciones</label>
            <textarea
              value={observaciones}
              onChange={(e) => setObservaciones(e.target.value)}
              placeholder="Opcional"
              maxLength={30}
            />
          </div>

          <div className="campo-caja">
            <label>Usuario</label>
            <div className="valor">Admin</div>
          </div>

          {/* Fila 4 (botón ocupa 2 columnas) */}
          <div className="campo-caja campo-accion">
            <BotonAccion type="submit">Cerrar caja</BotonAccion>
          </div>
        </form>
      </div>
    </div>
  );
}
